export const POSITION_PROPERTY_URL = 'position/property'
